<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{'Training Details'|translate}}</span>
            <button mat-icon-button (click)="close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-0">
        <iframe [src]="'/training-details/' + trainingId | safe: 'resourceUrl'"
                style="width: 100%; height: calc(90vh - 64px); border: none;">
        </iframe>
    </div>
</div>